import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Agendamento } from "../../../services/Agendamento";
import { useParams, useSearchParams } from "react-router-dom";
import { IAgendamentoDTO } from "../../../types/agendamento";
import { Pagamento } from "../../../services/Pagamento";
import { IFaturaDTO } from "../../../types/pagamento";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";

export const useInvoiceDetail = () => {
  const params = useParams();

  const [agendamento, setAgendamento] = useState<IAgendamentoDTO>(
    {} as IAgendamentoDTO
  );
  const [fatura, setFatura] = useState<IFaturaDTO>({} as IFaturaDTO);
  const getFatura = useCallback(() => {
    Pagamento.consultarFatura({ uuidAgendamento: params.uuidAgendamento })
      .then(({ data }) => {
        const value = data?.content?.find(
          (f) => f.status === StatusPagamentoEnum.pending
        );

        setFatura(value);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      );
  }, []);

  useEffect(() => {
    if (params?.uuidAgendamento) {
      Agendamento.getById({ uuid: params?.uuidAgendamento })
        .then(({ data }) => {
          setAgendamento(data);
        })
        .catch(
          ({
            response: {
              data: { mensagem },
            },
          }) => {
            toast.error(mensagem);
          }
        );
    }
    getFatura();
  }, [params?.uuidAgendamento]);

  return {
    agendamento,
    setAgendamento,
    fatura,
  };
};
